import DeliveryOption from '@/controllers/options/DeliveryOption';
import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';
import DeliveryOptionsProvider from '@/models/DeliveryOptionsProvider';
import IOptionHandler from './IOptionHandler';

class FlagItemOptionHandler implements IOptionHandler {
  execute(provider: DeliveryOptionsProvider, map: Map<string, unknown>): void {
    if (map.get(DeliveryOptionConstants.FLAG_ITEM)) {
      const deliveryOption: DeliveryOption = new DeliveryOption(DeliveryOptionConstants.FLAG_ITEM);
      deliveryOption.addSetting('value', 'true');
      provider.addDeliveryOption(deliveryOption);
    }
  }
}

export default FlagItemOptionHandler;
